import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Container = styled(Box)`
  width: 100%;
  height: 80px;
  border-bottom: 1px solid ${theme.colors.borderMedium};
  background: ${theme.colors.surfaceContainerBackground};

  .wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: ${theme.spacing.small}px ${theme.spacing.medium}px;

    .back-arrow-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;

      html[data-theme='light'] & .MuiIconButton-root:hover {
        background: ${theme.colors.menuItemHover};
      }

      svg path {
        stroke: ${theme.colors.devicesSecondaryText};
      }
    }

    .header-content {
      display: flex;
      flex-grow: 1;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      padding-left: ${theme.spacing.medium}px;
      gap: ${theme.spacing.md}px;

      .header-title {
        overflow: hidden;
        color: ${theme.colors.menuItemText};
        text-overflow: ellipsis;
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.xxxLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 48px;
      }
    }
  }
`
